import { selectSession } from 'src/app/session'
import ActionButton from 'src/components/ActionButton'
import SessionCard from 'src/components/session/SessionCard'
import {useAppSelector, useAppDispatch, useGetRunningContext} from 'src/hooks'
import Plus from '../Icon/Plus'
import HostEmptyHome from 'src/components/HostEmptyHome'
import { Session } from 'src/app/types'
import { setType } from 'src/app/modal'
import { setCurrentPage } from 'src/app/page'
import { selectAllSortedSessions } from 'src/app/allSessions'
import { HOST_SESSIONS_LIST_LENGTH } from 'src/constant'

const HostHome = () => {
  const activeSession = useAppSelector(selectSession)
  const dispatch = useAppDispatch()
  const sortedSessions = useAppSelector(selectAllSortedSessions)
  const topSessions = sortedSessions.slice(0, HOST_SESSIONS_LIST_LENGTH)
  const hasSessionsToShow = Boolean(sortedSessions?.length)
  const openCreateModal = () => {
    dispatch(setType({ type: 'sessionCreate' }))
  }

  const { isLoading, runningContext } = useGetRunningContext()

  const navigateToAllSessions = () => {
    dispatch(setCurrentPage({ page: 'AllSessions' }))
  }

  if (!hasSessionsToShow && !activeSession.id) {
    return <HostEmptyHome />
  }

  return (
    <div className="pt-3 pb-4">
      <div className="pb-6 sm:pb-3">
        { !isLoading && runningContext === 'inMeeting' && (
            <>
        <div className="sm:flex sm:justify-between">
          <h1 className="text-base font-bold pb-4 hidden sm:block">Home</h1>
          <ActionButton
            ariaLabel="new session"
            onClick={openCreateModal}
            padding="lg"
            type="primary"
            styles={`flex justify-center text-base whitespace-nowrap w-full sm:w-auto self-center ${
              activeSession?.id && 'hidden sm:flex'
            }`}
          >
            <span className="pt-0.5">
              <Plus id="large-new" size="20" box="18" />
            </span>
            <span className="ml-1">Create a New Session</span>
          </ActionButton>

        </div>
            </>
        )}
        {activeSession?.id && (
          <>
            <div className="flex h-6 mb-3 justify-between">
              <h2 className="text-base font-bold pb-3 text-darkBlack sm:font-[500] sm:text-sm">
                Active Session
              </h2>
              <ActionButton
                ariaLabel="new session"
                onClick={openCreateModal}
                padding="sm"
                type="primary"
                styles="flex sm:py-[6px] sm:px-4 sm:hidden"
              >
                <span className="pt-[1px]">
                  <Plus id="small-new" size="20" box="18" />
                </span>
                <span className="ml-1 block sm:hidden">New</span>
              </ActionButton>
            </div>
            <div className="grid md:grid-cols-cards">
              <SessionCard {...(activeSession as Required<Session>)} />
            </div>
          </>
        )}
      </div>
      {hasSessionsToShow && (
        <>
          <h2 className="text-base font-bold pb-3 text-darkBlack sm:font-[500] sm:text-sm">
            Recent Sessions
          </h2>
          <div className="pb-8 gap-3 grid md:grid-cols-cards">
            {topSessions.map((session) => (
              <SessionCard
                key={session.id}
                {...(session as Required<Session>)}
              />
            ))}
          </div>
          {sortedSessions?.length > HOST_SESSIONS_LIST_LENGTH && (
            <div className="text-center">
              <ActionButton
                ariaLabel="view all sessions"
                type="secondary"
                onClick={navigateToAllSessions}
                padding="lg"
              >
                View All Sessions
              </ActionButton>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default HostHome
